import React, { useState, useEffect } from "react";
import { ChevronLeft, ChevronRight } from "lucide-react";
import * as Constants from '../../constants';
import {  useNavigate,  } from 'react-router-dom';
// 4 existing + 23 new (total 27)
export function EventPhotosHero() {
  const [currentSlide, setCurrentSlide] = useState(0);
  const [isHovered, setIsHovered] = useState(false);
  const [galleries, setGalleries] = useState([]);
  const [loading, setLoading] = useState(false);
  const [gal, setGal] = useState(null);
const navigate = useNavigate();
   useEffect(() => {
      onLoadGallery();
    },[] );
  // Auto-slide functionality
  useEffect(() => {
    if (!isHovered && galleries.length>0) {
      const interval = setInterval(() => {
        setCurrentSlide((prev) => (prev + 1) % galleries.length);
      }, 5000);
      return () => clearInterval(interval);
    }
  }, [isHovered,galleries]);

  const nextSlide = () => {
    setCurrentSlide((prev) => (prev + 1) % galleries.length);
  };

  const prevSlide = () => {
    setCurrentSlide((prev) => (prev - 1 + galleries.length) % galleries.length);
  };

  const onLoadGallery = async () => {
      try {
        setLoading(true);
        const resp = await fetch(`${Constants.apiUrl}/cms/gallery/slider`, {
          method: "GET",
          headers: {
            "Content-Type": "application/json",
          },
        });
        const data = await resp.json();
        setLoading(false);
        if (data.code == 0) {
          setGalleries(data.items);
          setGal(data.gal);
        }
      } catch (error) {
        setLoading(false);
        console.error(error);
      }
    };

  return (
    <section className="relative py-6 lg:py-8 bg-gray-50 dark:bg-gray-900 overflow-hidden">
      <div className="container mx-auto px-4 py-2 sm:px-6 max-w-7xl">
        {/* Two Column Layout */}
        <div className="grid grid-cols-1 lg:grid-cols-10 gap-6 lg:gap-8 items-stretch">
          
          {/* Left Column: Event Photos Slider */}
          <div className="lg:col-span-7 flex flex-col">
            <div
              className="relative flex-1"
              onMouseEnter={() => setIsHovered(true)}
              onMouseLeave={() => setIsHovered(false)}
            >
              <div className="relative h-[320px] lg:h-[380px] rounded-2xl overflow-hidden shadow-2xl">
                {/* Background Images */}
                {galleries.map((photo, index) => (
                  <div
                    key={photo.id}
                    className={`absolute inset-0 transition-all duration-1000 ease-out ${
                      index === currentSlide
                        ? "opacity-100 scale-100"
                        : "opacity-0 scale-105"
                    }`}
                  >
                    <img
                       src={`${Constants.docUrl}/cms/gallery/${gal.id}/${photo.coverImage}`}
                        alt={photo.title}
                      className="w-full h-full object-cover object-center"
                    />

                    {/* Overlay */}
                    <div className="absolute inset-0 bg-gradient-to-t from-black/20 via-transparent to-transparent opacity-40" />

                    {/* Caption */}
                    <div className="absolute bottom-6 left-6 right-6">
                      <div className="bg-white/95 backdrop-blur-md rounded-lg px-4 py-2 inline-block border border-blue-200/50 shadow-lg">
                        <p className="text-blue-800 font-medium text-sm lg:text-base">
                          {photo.title}
                        </p>
                      </div>
                    </div>
                  </div>
                ))}

                {/* Navigation Arrows */}
                <div
                  className={`absolute inset-0 flex items-center justify-between px-6 transition-opacity duration-300 ${
                    isHovered ? "opacity-100" : "opacity-0"
                  }`}
                >
                  <button
                    onClick={prevSlide}
                    className="bg-white/95 hover:bg-white text-blue-800 p-2 lg:p-3 rounded-full shadow-xl transition-all duration-200 hover:scale-110 backdrop-blur-md border border-blue-200/30"
                    aria-label="Previous photo"
                  >
                    <ChevronLeft className="w-4 h-4 lg:w-5 lg:h-5" />
                  </button>
                  <button
                    onClick={nextSlide}
                    className="bg-white/95 hover:bg-white text-blue-800 p-2 lg:p-3 rounded-full shadow-xl transition-all duration-200 hover:scale-110 backdrop-blur-md border border-blue-200/30"
                    aria-label="Next photo"
                  >
                    <ChevronRight className="w-4 h-4 lg:w-5 lg:h-5" />
                  </button>
                </div>

                {/* Photo Counter */}
                <div className="absolute top-4 right-4 bg-black/60 text-white px-3 py-1 rounded-full text-sm backdrop-blur-sm">
                  {currentSlide + 1} of {galleries.length}
                </div>
              </div>

              {/* Slide Indicators */}
              <div className="flex justify-center gap-2 mt-4">
                {galleries.map((_, index) => (
                  <button
                    key={index}
                    onClick={() => setCurrentSlide(index)}
                    className={`h-2 rounded-full transition-all duration-300 ${
                      index === currentSlide
                        ? "bg-blue-600 dark:bg-blue-400 w-8 shadow-lg"
                        : "bg-gray-300 dark:bg-gray-600 w-2 hover:bg-gray-400 dark:hover:bg-gray-500"
                    }`}
                    aria-label={`Go to photo ${index + 1}`}
                  />
                ))}
              </div>
            </div>
          </div>

          {/* Right Column: Description */}
          <div className="lg:col-span-3 flex flex-col">
            <div className="bg-white dark:bg-gray-800 p-5 lg:p-6 rounded-2xl shadow-2xl border border-gray-100 dark:border-gray-700 h-full">
              <div className="space-y-5">
                <div>
                  <h1 className="text-xl lg:text-2xl font-bold text-gray-900 dark:text-white mb-2">
                    Lagos State Judiciary
                  </h1>
                  <p className="text-sm text-gray-600 dark:text-gray-300 leading-relaxed">
                    Serving justice with integrity, transparency, and excellence for
                    the people of Lagos State.
                  </p>
                </div>

                <div className="grid grid-cols-2 gap-3">
                  <div className="bg-blue-50 dark:bg-blue-900/20 p-3 rounded-lg border border-blue-200/50 dark:border-blue-700/30">
                    <div className="text-lg font-bold text-blue-600 dark:text-blue-400">
                      7
                    </div>
                    <div className="text-xs text-blue-800 dark:text-blue-300">
                      Court Divisions
                    </div>
                  </div>
                  <div className="bg-blue-50 dark:bg-blue-900/20 p-3 rounded-lg border border-blue-200/50 dark:border-blue-700/30">
                    <div className="text-lg font-bold text-blue-600 dark:text-blue-400">
                      24/7
                    </div>
                    <div className="text-xs text-blue-800 dark:text-blue-300">
                      E-Filing Access
                    </div>
                  </div>
                </div>

                <div className="space-y-3">
                  <h3 className="font-semibold text-gray-900 dark:text-white text-sm">
                    Quick Access
                  </h3>
                  <div className="space-y-2">
                    <button className="w-full border-2 border-blue-600 text-blue-600 hover:bg-blue-50 dark:hover:bg-blue-900/20 py-2.5 px-4 rounded-lg transition-colors duration-200 font-medium dark:border-blue-400 dark:text-blue-400 text-sm"
                    onClick={()=>navigate("/online-search")}>
                      Case Lookup
                    </button>
                    <button className="w-full border border-gray-300 dark:border-gray-600 text-gray-700 dark:text-gray-300 hover:bg-gray-50 dark:hover:bg-gray-800 py-2.5 px-4 rounded-lg transition-colors duration-200 font-medium text-sm">
                      Download Forms
                    </button>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
